const { LayoutProvider } = require("core/contexts/layout");
const { AuthProvider } = require("core/contexts/auth");
const { StripeProvider } = require("core/contexts/stripe");
const { CurrencyProvider } = require("core/contexts/currency");
const { ExperiencerProvider } = require("core/contexts/experiencer");
const { HostProvider } = require("core/contexts/host");
const { ContractProvider } = require("core/contexts/contract");
const { ExperiencesProvider } = require("core/contexts/experience");
const { ScheduleProvider } = require("core/contexts/schedule");
const { BookingProvider } = require("core/contexts/booking");
const { ReportProvider } = require("core/contexts/reports");

const AppProvider = ({ children }) => {
    return (
        <LayoutProvider>
            <AuthProvider>
                <StripeProvider>
                    <CurrencyProvider>
                        <ExperiencerProvider>
                            <HostProvider>
                                <ContractProvider>
                                    <ExperiencesProvider>
                                        <ScheduleProvider>
                                            <BookingProvider>
                                                <ReportProvider>{children}</ReportProvider>
                                            </BookingProvider>
                                        </ScheduleProvider>
                                    </ExperiencesProvider>
                                </ContractProvider>
                            </HostProvider>
                        </ExperiencerProvider>
                    </CurrencyProvider>
                </StripeProvider>
            </AuthProvider>
        </LayoutProvider>
    );
};

export default AppProvider;
